import { render, staticRenderFns } from "./IconShoppingCart.vue?vue&type=template&id=05f75dbb&scoped=true&"
import script from "./IconShoppingCart.vue?vue&type=script&lang=ts&"
export * from "./IconShoppingCart.vue?vue&type=script&lang=ts&"
import style0 from "./IconShoppingCart.vue?vue&type=style&index=0&id=05f75dbb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f75dbb",
  null
  
)

export default component.exports